import {
  computed,
  ref,
  reactive,
  onBeforeMount,
  defineEmits,
  getCurrentInstance,
  watch,
} from "vue";
const useMenu = (emit) => {
  const {
    appContext: {
      config: { globalProperties: global },
    },
  } = getCurrentInstance();

  const isCollapse = ref(false);
  const onlyOneChild = ref({});
  const defaultActive = ref(null);
  watch(
    () => global.$route,
    (newVal) => {
      defaultActive.value = newVal?.meta?.activePath
        ? newVal.meta.activePath
        : newVal?.path;
    },
    {
      deep:true,
      immediate: true,
    }
  );
  return {
    sidebarClass: computed(() => ({
      hideSidebar: isCollapse.value,
      openSidebar: !isCollapse.value,
    })),
    onlyOneChild,
    isCollapse,
    defaultActive,
    hasOneShowingChild(children, parent) {
      /**
       children 为null时，形参不为默认值而为null,
       当children 为null或者undefined时,下边onlyOneChild.value中的children仍然为null/undefined
       *  */
      if (!children) {
        children = [];
      }
      const showingChildren = children.filter((item) => {
        if (item.hidden) {
          return false;
        } else {
          onlyOneChild.value = item;
          return true;
        }
      });

      if (showingChildren[0]?.meta?.showParent) {
        return false;
      }

      if (showingChildren.length === 1) {
        return true;
      }

      if (showingChildren.length === 0) {
        Object.assign(onlyOneChild.value,{ ...parent, path: "", noShowingChildren: true });
        return true;
      }
      return false;
    },

    hasTitle(title = "") {
      if (title.length > 5) {
        return title;
      } else {
        return "";
      }
    },
    toggleSidebar() {
      isCollapse.value = !isCollapse.value;
      // if (this.sidebar.hide) {
      //   return false;
      // }
      // this.sidebar.opened = !this.sidebar.opened;
      // this.sidebar.withoutAnimation = withoutAnimation;
      // if (this.sidebar.opened) {
      //   Cookies.set("sidebarStatus", 1);
      // } else {
      //   Cookies.set("sidebarStatus", 0);
      // }
    },
  };
};
export default useMenu;
